import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entity: {}
    },

    mutations: {
        SET_ENTITY(state, payload) {
            state.entity = { ...payload };
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async get({ commit }, { site_id }) {
            const { data } = await axios.get(`/admin/sites/${ site_id }/setting`);
            data.delivery = data.delivery || { allow_delivery_outside_zones: false };
            data.payment = data.payment || {};
            data.yandex_delivery = data.yandex_delivery || {};
            commit('SET_ENTITY', data);
            return data;
        },
        async save({ commit, state }, { site_id }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/sites/${ site_id }/setting/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/sites/${ site_id }/setting`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { site_id, id }) {
            await axios.delete(`/admin/sites/${ site_id }/setting/${ id }`);
        },
    },

    getters: {}
}
